module.exports = __webpack_public_path__ + "static/media/layout-graphic-two.20e74b1c.svg";